import { useApiGet } from '../../shared/api/utils/reactQueryProvider';
import { getAuth } from '../api/services/Auth';
import { User } from '../types/user';

export const useGetAuth = () => {
  return useApiGet<User>(['getAuth'], getAuth, { enabled: true, refetchOnWindowFocus: true });
};
